/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.academics.prerequisites'},
});

const PrerequisitesItem = () => (
  <RouteLinkItem
    route="midas/settings/academics/prerequisites"
    title={messages.title}
  />
);

export default PrerequisitesItem;
